import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';
import { ToastrService } from 'ngx-toastr';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { ConfirmationDialogService } from '../confirmation-dialog/confirmation-dialog.service';

@Component({
  selector: 'app-empfind',
  templateUrl: './empfind.component.html',
  styleUrls: ['./empfind.component.css']
})
export class EmpfindComponent implements OnInit {

  showProgress: boolean = false;


  empColl: any = [];

  checkempColl: any = [];

  searchtxt: any = "";
  columnDefs = [
    { headerName: 'Action', field: 'ischeck',type:'checkbox' },
    { headerName: 'Code', field: 'staffcode' },
    { headerName: 'EmployeeName', field: 'empname', width: 300, minWidth: 300 },
    { headerName: 'Designation', field: 'designationname' },
    { headerName: 'Branch', field: 'branchname', width: 300, minWidth: 300 },
    { headerName: 'Department', field: 'departmentname', width: 300, minWidth: 300 },
  ]

  gridOptions = {
    enableactioncol: false,
    columnDefs: this.columnDefs,
    pageindex: 1,
    enablecheckboxapply:false
  };

  constructor(private toastr: ToastrService, private appService: AppdataService,
    private loginService: LoginserviceService, private activeModal: NgbActiveModal, private confirmationDialogService: ConfirmationDialogService,
    private productFindService: NgbModal,) {

  }

  @Output() emitData = new EventEmitter();


  ngOnInit() {
    this.fngetEmp()

  }

  //Get
  fngetEmp() {
    if (this.showProgress) {
      return
    }

    this.fnShowProgress();

    var data = {
      'empid': 0,
      'designationid': 0,
      'payrollgrpid': 0,
      'branchid': 0,
      'departmentid': 0,
      'locationid': 0,
      'nationalityid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
      'filterstatus': "",
      'fromdate': null,
      'todate':null,
    }
    this.appService.getEmpListView(data)
      .subscribe(
        (res) => {
          this.fnHideProgress();
          if (res.json().status === 200) {
            this.empColl = res.json().result;
                
          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.fnHideProgress();
          this.toastr.error('Error', err);
        })
  }

  fnCheckBoxApply(data){
    this.checkempColl=[]
    this.checkempColl=data      

    console.log(data)
    console.log(this.checkempColl)
  }


  fnApplyCheck() {
    this.emitData.emit(this.checkempColl);  
    this.activeModal.close(true);  
  
  }

  fnResetGrid(data) {
    this.searchtxt = data;
    this.gridOptions.pageindex = 1
  }
  
  public decline() {
    this.activeModal.close(false);
  }


  private fnShowProgress() {
    this.showProgress = true;
  }
  private fnHideProgress() {
    this.showProgress = false;
  }


  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }




}
